import Amex from '@/images/payments/amex.svg';
import ApplePay from '@/images/payments/applepay.svg';
import Diners from '@/images/payments/diners.svg';
import Discover from '@/images/payments/discover.svg';
import GooglePay from '@/images/payments/googlepay.svg';
import JcbLogo from '@/images/payments/jcb-card.svg';
import Link from '@/images/payments/link.svg';
import MasterCard from '@/images/payments/mastercard.svg';
import PayPal from '@/images/payments/paypal.svg';
import Union from '@/images/payments/union.svg';
import Visa from '@/images/payments/visa.svg';

export const paymentMethodLogos = {
	amex: Amex,
	applePay: ApplePay,
	diners: Diners,
	discover: Discover,
	googlePay: GooglePay,
	link: Link,
	mastercard: MasterCard,
	mc: MasterCard,
	paypay: PayPal,
	unionpay: Union,
	visa: Visa,
	visacredit: Visa,
	jcb: JcbLogo
};

export const walletLogos = {
	google_pay: GooglePay,
	apple_pay: ApplePay
};
